import GamePostMessageListenerBase from '../../../../game/post_messages/game_post_messages_listener_base';
import _ from '../../../../../utils/underscore';
import Device from '../../../../../utils/device/device';

const NYX_EVENTS = {
    GO_TO_LOBBY: "GOTO_LOBBY",
    OPEN_CASHIER: "CASHIER",
    OPEN_RESPONSIBLE_GAMING: "RESPONSIBLE_GAMING",
    OPEN_GAME_HISTORY: "OPEN_GAME_HISTORY",

    GAME_ANIMATION_COMPLETE: "gameanimationcomplete",
    GAME_REVEALED: "gamerevealed",
    REDIRECT: "redirect"
}

const NYX_ACTION_MAP = {
    [NYX_EVENTS.GO_TO_LOBBY]: 'lobby',
    [NYX_EVENTS.OPEN_CASHIER]: 'cashier',
    [NYX_EVENTS.OPEN_RESPONSIBLE_GAMING]: 'responsiblegaming',
    [NYX_EVENTS.OPEN_GAME_HISTORY]: 'history',

    [NYX_EVENTS.GAME_ANIMATION_COMPLETE]: 'gameroundend',
    [NYX_EVENTS.GAME_REVEALED]: 'gameready',
    [NYX_EVENTS.REDIRECT]: 'redirect'
}

export default class NyxGamePostMessageListener extends GamePostMessageListenerBase {
    static CLASS = 'NyxGamePostMessageListener';



    init(params){
        super.init(params);

        params = params || {};
        if(!params.gameOptions) {
            this.throwArgumentExpected('37', 'init', 'gameOptions');
        }

        if(!params.serviceFactory) {
            this.throwArgumentExpected('41', 'init', 'serviceFactory');
        }

        this._gameOptions = params.gameOptions;
        this._serviceFactory = params.serviceFactory;
    }


    processPostMessage(messageData) {
        const actionName = this._extractActionName(messageData);

        if (actionName) {
            this._gameOptions.postMessageHandler.executeAction(this._gameOptions, actionName);
        }
    }

    _extractActionName(messageData) {
        if (!messageData) {
            return null;
        }

        const message = this._parsePostMessageData(messageData);
        const gcmevent =  message.gcmevent && message.gcmevent.toLowerCase();

        this.logger.debug('Received event name:', message.EventId, gcmevent, messageData);

        if(NYX_ACTION_MAP.hasOwnProperty(message.EventId)) {
            this.logger.debug('Found action match:', message.EventId + ' = ' + NYX_ACTION_MAP[ message.EventId ]);

            return NYX_ACTION_MAP[ message.EventId ];
        }

        if(NYX_ACTION_MAP.hasOwnProperty(gcmevent)) {
            this.logger.debug('Found GCM action match:', gcmevent + ' = ' + NYX_ACTION_MAP[ gcmevent ]);

            if(gcmevent === NYX_EVENTS.REDIRECT){
                if(Device.hybrid.isEmbedded) {
                    return 'lobby';
                } else if (message.url === 'https://nyx.orbit.888casino.com/lobby') {
                    return 'lobby';
                } else if (message.url === 'https://nyx.orbit.888casino.com/deposit') {
                    return 'cashier';
                } else {
                    return null;
                }
            }

            return NYX_ACTION_MAP[ gcmevent ];
        }

        this.logger.debug('No action match for event:', message.EventId, gcmevent, messageData);
        return null;
    }

    _parsePostMessageData(messageData) {
        if (_.isString(messageData)) {
            try {
                return JSON.parse(messageData);
            } catch(e) {}
        }

        if (_.isObject(messageData)) {
            return messageData;
        }

        return {};
    }
}